import ReadonlyFormTable from "@/components/ReadonlyFormTable";
import {FormattedDialogTitle} from "@dvrt/graphql-widgets";
import {Checkbox, Dialog, DialogContent} from "@mui/material";
import {DataSource} from "./DataSource";
import {FC, useMemo} from "react";
import {commonTranslations} from "@/utils/translations";
import {FormattedMessage, MessageDescriptor} from "react-intl";

const ReadonlyView = ({dataSource}: {dataSource: DataSource}) => {
    if (dataSource.state !== "ok") {
        return null;
    }

    const data = useMemo(
        () => ({
            macAddress: dataSource.device.macAddress,
            vendor: dataSource.device.vendor.name,
            provisioning: dataSource.device.provisioning,
            variant: dataSource.device.variant,
            useDisplayNameForStationName: dataSource.device.useDisplayNameForStationName,
        }),
        [dataSource],
    );

    return (
        <DialogContent>
            <ReadonlyFormTable
                data={data}
                fields={{
                    macAddress: {
                        label: commonTranslations.macAddress,
                    },
                    vendor: {
                        label: commonTranslations.vendor,
                    },
                    provisioning: {
                        label: commonTranslations.provisioning,
                        render: (value) => <Checkbox checked={value} disabled sx={{padding: 0}} />,
                    },
                    variant: {
                        label: commonTranslations.variant,
                        render: (value) =>
                            value ? <span>{value}</span> : <FormattedMessage {...commonTranslations.default} />,
                    },
                    useDisplayNameForStationName: {
                        label: commonTranslations.stationName,
                        render: (value) => (
                            <span>
                                <FormattedMessage
                                    {...(value
                                        ? commonTranslations.useDisplayNameForStationName.useDisplayName
                                        : commonTranslations.useDisplayNameForStationName.useE164)}
                                />
                            </span>
                        ),
                    },
                }}
            />
        </DialogContent>
    );
};

type Props = {
    isOpen: boolean;
    close: () => void;
    title: MessageDescriptor;
    titleValues: Record<string, any>;
    dataSource: DataSource;
};

const ReadonlyDialog: FC<Props> = ({isOpen, close, title, titleValues, dataSource}) => {
    return (
        <Dialog open={isOpen} onClose={close}>
            <FormattedDialogTitle title={title} values={titleValues} closingButton onClose={close} />
            <ReadonlyView dataSource={dataSource} />
        </Dialog>
    );
};

export default ReadonlyDialog;
